import { useContext } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
export function useGate(gate) {
  const {
    gates
  } = useContext(UserInfoContext);
  return (gates === null || gates === void 0 ? void 0 : gates.includes(gate)) || false;
}